import { stringify } from "qs";
import t from "../../app/i18n";
import type { ErrorResponse, FieldConstraintViolation, NormalizedError } from "../types";
import { Notification } from "./notificationUtils";

export const serializeParams = (params: any) => {
  return stringify(params, { arrayFormat: "repeat", skipNulls: true });
};

export const showErrorResponseNotification = (errorResponse: ErrorResponse) => {
  if (errorResponse.errors && errorResponse.errors.length > 0) {
    Notification.getNotification().error({
      title: errorResponse.message,
      description: errorResponse.errors.join(" "),
    });
  } else {
    Notification.getNotification().error({
      title: t("common.error"),
      description: errorResponse.message,
      key: errorResponse.message,
    });
  }
};

export const normalizeError = (
  status?: number,
  message: string | undefined = undefined,
  violations: FieldConstraintViolation[] | undefined = undefined,
): NormalizedError => ({
  serverResponded: !!status,
  status,
  message,
  violations,
});

export const blobToErrorResponse = (blob: Blob): Promise<ErrorResponse> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(JSON.parse(reader.result as string));
    reader.readAsText(blob);
  });
};
